import useBreakpoints from '../useBreakpoints/index.js';
const useIsDesktop = () => {
  const {
    isAboveBreakpoint
  } = useBreakpoints();
  return isAboveBreakpoint('lg', true);
};
export default useIsDesktop;